import { all, takeEvery, put, call } from "redux-saga/effects";
import actions from "./actions";
import { getList, addData } from "../../helpers/fackBackend_Helper";

function* checkStatusResponse({ payload: { data } }) {
    try {
        const response = yield call(addData, '/API/V1/Status/CheckStatus', data);
        if (response?.statusCode == 1200) {
            yield put(actions.checkStatusSuccess(response?.data));
        } else {
            yield put(actions.checkStatusError(response?.message));
        }
    } catch (error) {
        yield put(actions.checkStatusError(error));
    }
}


function* checkDataUsageResponse({ payload: { data } }) {
    try {
        const response = yield call(addData, '/API/V1/Status/SubscriberUsageStatus', data);
        // const response =  {
        //         "statusCode": 1200,
        //         "data": [
        //             {
        //                 category: "MESSAGE",
        //                 bucketValue: "100",
        //                 bucketValueUnit: "MESSAGE",
        //                 used: "0",
        //                 remaining: "100",
        //                 unit: "MESSAGE",
        //                 currentBehavior: "Active",
        //                 subscriberStatusChangedDate: "03-09-26 19:12:31",
        //                 expiryDateTime: "03-10-26 09:29:59",
        //             },
        //             {
        //                 category: "DATA",
        //                 bucketValue: "10",
        //                 bucketValueUnit: "GB",
        //                 used: "2",
        //                 remaining: "8",
        //                 unit: "GB",
        //                 currentBehavior: "Active",
        //                 subscriberStatusChangedDate: "03-09-26 19:12:31",
        //                 expiryDateTime: "03-10-26 09:29:59",
        //             },
        //             {
        //                 category: "VOICE",
        //                 bucketValue: "500",
        //                 bucketValueUnit: "MIN",
        //                 used: "150",
        //                 remaining: "350",
        //                 unit: "MIN",
        //                 currentBehavior: "Inactive",
        //                 subscriberStatusChangedDate: "03-09-26 19:12:31",
        //                 expiryDateTime: "03-10-26 09:29:59",
        //             },
        //         ],
        //         "message": "Success"
        //     };
        
        if (response?.statusCode == 1200) {
            yield put(actions.checkDataUsageSuccess(response?.data));
        } else {
            yield put(actions.checkDataUsageError(response?.message));
        }
    } catch (error) {
        yield put(actions.checkDataUsageError(error));
    }
}

export default function* rootSaga() {
    yield all([
        takeEvery(actions.CHECK_STATUS, checkStatusResponse),
        takeEvery(actions.CHECK_DATA_USAGE, checkDataUsageResponse),
    ])
}